'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const { getReferralSource } = require('../../support/redemption-helper');

function RedemptionRedirect({
  routes,
  offerId,
  referralSource,
  directRedemption,
}) {
  let redirectRoute = routes.redirect.offers.replace('{offerId}', offerId);

  referralSource = getReferralSource({
    referralSource,
    offerId,
    directRedemption,
  });

  if (referralSource) {
    redirectRoute += `?referralSource=${referralSource}`;
  }

  return h(
    'a.redemption-modal-button',
    {
      href: redirectRoute,
      target: '_blank',
      rel: 'noopener',
      'data-bhc': `direct-link:${offerId}`,
    },
    h(Translate, 'js.modules.redemption.ShopNow')
  );
}

module.exports = RedemptionRedirect;
